// @flow

import React from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { Switch } from '../../components';

const rowNames = [
  '', '', 'EP', 'MP', 'CO', 'BU', 'SB', 'BB', '',
];

const colNames = [
  '', '', 'EP', 'MP', 'CO', 'BU', 'SB', 'BB', '',
];

type Props = {
  tableData: Array<{
    x: number,
    y: number,
    name: string,
    percents: number,
    bg_color: string,
  }> | undefined,
  setVs3bet: (boolean) => void,
  isVs3bet: boolean,
  setVs4bet: (boolean) => void,
  isVs4bet: boolean,
  setIsEasy: (boolean) => void,
  isEasy: boolean,
  setPercents: (any) => void,
  isFreeUser?: boolean,
}

const ResultTable = ({
  tableData,
  setVs3bet,
  isVs3bet,
  setVs4bet,
  isVs4bet,
  setIsEasy,
  isEasy,
  setPercents,
  isFreeUser,
}: Props) => {
  const { user } = useSelector((state) => state.profile);
  const isTrial = user?.rate?.toLowerCase() === 'trial';

  const setCells = (x, indexX, y, indexY, dataArr) => {
    if (indexX === 0 && indexY === 0) {
      return (
        <div key={`${indexX}_${indexY}`} className={styles.same}>
          <Switch
            isOn={isVs3bet}
            handleToggle={() => {
              if (!isFreeUser) {
                setVs3bet(!isVs3bet);
                setVs4bet(false);
                setIsEasy(false);
              }
            }}
            disabled={isFreeUser}
          />
          <p>vs 3bet</p>
        </div>
      );
    }
    if (indexX === 8 && indexY === 0) {
      return (
        <div key={`${indexX}_${indexY}`} className={styles.same}>
          <Switch
            isOn={isVs4bet}
            handleToggle={() => {
              if (!isFreeUser) {
                setVs4bet(!isVs4bet);
                setVs3bet(false);
                setIsEasy(false);
              }
            }}
            disabled={isFreeUser}
          />
          <p>vs 4bet</p>
        </div>
      );
    }
    if (indexX === 1 && indexY === 1) {
      return (
        <div key={`${indexX}_${indexY}`} className={styles.same}>
          <Switch
            isOn={isEasy}
            handleToggle={() => {
              if (!isFreeUser) {
                setIsEasy(!isEasy);
                setVs3bet(false);
                setVs4bet(false);
              }
            }}
            disabled={isFreeUser}
          />
          <p>Easy RFI</p>
        </div>
      );
    }
    if ((dataArr.filter((item) => (item.y === indexX && item.x === indexY))).length) {
      const isCO = indexX === 4 && indexY === 1;
      const item = (dataArr.filter((v) => (
        v.y === indexX && v.x === indexY)))[0];
      const isComplexButton = (indexX === 6 && indexY === 1) || (indexX === 7 && indexY === 6)
        || (indexX === 6 && indexY === 7);
      const itemsLength = (dataArr.filter((it) => (
        it.y === indexX && it.x === indexY))).length;

      if (isComplexButton && itemsLength === 2) {
        const items = (dataArr.filter((it) => (
          it.y === indexX && it.x === indexY))).sort((a, b) => a.name.includes('no limp') - b.name.includes('no limp'));

        return (
          <>
            <button
              onMouseOver={() => setPercents(
                { counter: items[0]?.counter, streak: items[0]?.streak },
              )}
              onFocus={() => setPercents({ counter: items[0]?.counter, streak: items[0]?.streak })}
              onMouseOut={() => setPercents('')}
              onBlur={() => setPercents('')}
              key={`${indexX}_${indexY}_1`}
              type="button"
              className={cx(
                styles.fullCell,
                styles.halfCell,
                styles.rightBorder,
                { [`${styles.disable}`]: (isTrial && !isCO) },
              )}
              disabled={(isTrial && !isCO)}
              style={{ background: items[0]?.bg_color }}
            >
              <p className={`${styles.name} ${styles.smallText}`}>{items[0]?.name}</p>
              <p className={`${styles.percents} ${styles.smallText}`}>
                {
                items[0]?.percents ? (
                  <>
                    {items[0]?.percents}
                    %
                  </>
                ) : 'n/a'
              }
              </p>
            </button>
            <button
              onMouseOver={() => setPercents(
                { counter: items[1]?.counter, streak: items[1]?.streak },
              )}
              onFocus={() => setPercents({ counter: items[1]?.counter, streak: items[1]?.streak })}
              onMouseOut={() => setPercents('')}
              onBlur={() => setPercents('')}
              key={`${indexX}_${indexY}_2`}
              type="button"
              className={cx(
                styles.fullCell,
                styles.halfCell,
                { [`${styles.disable}`]: (isTrial && !isCO) },
              )}
              disabled={(isTrial && !isCO)}
              style={{ background: items[1]?.bg_color }}
            >
              <p className={`${styles.name} ${items[1]?.name === 'vs SB no limp 4bet' ? styles.smallestText : styles.smallText}`}>{items[1]?.name}</p>
              <p className={`${styles.percents} ${items[1]?.name === 'vs SB no limp 4bet' ? styles.smallestText : styles.smallText}`}>
                {
                items[1]?.percents ? (
                  <>
                    {items[1]?.percents}
                    %
                  </>
                ) : 'n/a'
              }
              </p>
            </button>
          </>
        );
      }
      return (
        <button
          onMouseOver={() => setPercents(
            { counter: item?.counter, streak: item?.streak },
          )}
          onFocus={() => setPercents({ counter: item.counter, streak: item?.streak })}
          onMouseOut={() => setPercents('')}
          onBlur={() => setPercents('')}
          key={`${indexX}_${indexY}`}
          type="button"
          className={cx(
            styles.fullCell,
            { [`${styles.disable}`]: (isTrial && !isCO) },
          )}
          disabled={(isTrial && !isCO)}
          style={{ background: item?.bg_color }}
        >
          <p className={styles.name}>{item?.name}</p>
          <p className={styles.percents}>
            {
              item?.percents ? (
                <>
                  {item?.percents}
                  %
                </>
              ) : 'n/a'
            }
          </p>
        </button>
      );
    }
    if (indexY === 0 && indexX > 0) {
      return <div key={`${indexX}_${indexY}`} className={styles.labelCells}>{colNames[indexX]}</div>;
    }
    if (indexX === 0 && indexY > 0) {
      return <div key={`${indexX}_${indexY}`} className={styles.labelCells}>{rowNames[indexY]}</div>;
    }
    if (!(dataArr.filter((item) => (item.y === indexX && item.x === indexY))).length
      && indexX > 0
      && indexX !== indexY) {
      return <div key={`${indexX}_${indexY}`} className={styles.empty} />;
    }
    return <div key={`${indexX}_${indexY}`} className={styles.same} />;
  };

  return (
    <section className={styles.matrix}>
      {rowNames.map((cellY, y) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={styles.row} key={y}>
          {colNames.map((cellX, x) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${x}_${y}`} className={styles.cell}>{setCells(cellX, x, cellY, y, tableData)}</div>
          ))}
        </div>
      ))}
    </section>
  );
};

export default ResultTable;
